function appreviewAnlegen(benutzerId, appreviewReason) {
  const mutation = {
    query: 'mutation appreviewAnlegen($benutzerId: Int!, $appreviewReason: AppreviewReason!) { appreviewAnlegen(benutzerId: $benutzerId, appreviewReason: $appreviewReason)}',
    variables: {
      benutzerId,
      appreviewReason
    }
  }
  graphql(mutation).then(json => {
    // console.log(json)
  })
}

function triggerAppreview() {
  if (typeof (Android) != 'undefined') {
    Android.appReview()
  }
  if (window.webkit) {
    window.webkit.messageHandlers.appReview.postMessage('')
  }
}

window.addEventListener('DOMContentLoaded', function() {
  if (viewConfig.appreview) {
    setTimeout(() => {
      appreviewAnlegen(viewConfig.appreview.benutzerId, viewConfig.appreview.appreviewReason)
      triggerAppreview()
      // console.log('appreview triggered after delay')
    }, viewConfig.appreview.delayMilliseconds)
  }
})

